import React, { useCallback, useEffect, useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import { InputCurrency, InputQuantity, Loading, ImageModal } from '../../components/Main'
import ReturnShippingModal from './ReturnShippingModal'
import { t } from 'i18next'
import { cleanNumber, checkValidationFile, currencyFormatDecimal } from '../../utility/Helpers'
import { confirmationAlert, showAlert } from '../../utility/SweetAlert'
import Compressor from 'compressorjs'
import { useSelector } from 'react-redux'
import { InteractorUpdateImage } from '../../interactors/Main'

const ReturnItemsSection = ({
  label,
  orderData,
  dataShipping,
  items,
  setItems,
  totalData,
  setTotalData,
  error,
  setError,
  detailReturn,
  setDetailReturn,
}) => {
  const { account } = useSelector((state) => state.account)
  const pathSegments = window.location.pathname.split('/')
  const currentPage = pathSegments[2]
  // const [productList, setProductList] = useState([])
  // const { productSearch } = InteractorProductItemSearch()
  const { uploadImage } = InteractorUpdateImage()
  const [internalLoading, setInternalLoading] = useState(currentPage === 'view')
  const [showModal, setShowModal] = useState(false)
  const [pagination, setPagination] = useState()
  const [keyword, setKeyword] = useState('')
  const [payloadItemsSearch, setPayloadItemsSearch] = useState({
    page: 1,
    limit: 10,
    keywords: {
      province_uid: [],
      category_main_uid: null,
      category_major_uid: null,
      category_minor_uid: null,
      store_uid: orderData?.store_uid || '',
      price_range: {
        minimum: null,
        maximum: null,
      },
      status: '',
      rating: null,
      text_search: '',
      sort_by: null,
      source: 'MARKETPLACE-CORRECTION',
    },
  })

  // const handleItemsSearchResponse = (response) => {
  //   if (response?.items) {
  //     const correctionItemsList = response.items.map((item) => ({
  //       product_title: item.product_title,
  //       product_quantity: item.minimum_order_quantity,
  //       product_minimum_order_quantity: item.minimum_order_quantity,
  //       product_price: item.product_price,
  //       product_total_price: item.product_price * item.minimum_order_quantity,
  //       product_thumbnail: item.product_thumbnail,
  //       product_type: item.product_type,
  //       product_uid: item.uid,
  //       product_unit_type: item.product_unit_type,
  //     }))
  //     setProductList(correctionItemsList)
  //     setPagination(response.pages)
  //   }
  // }

  const handleChangePage = (newPage) => {
    const updatedPayload = { ...payloadItemsSearch, page: newPage }
    setPayloadItemsSearch(updatedPayload)
    // productSearch(updatedPayload, handleItemsSearchResponse, () => {})
  }

  const handleResetPagination = () => {
    setPayloadItemsSearch((prev) => ({ ...prev, page: 1 }))
  }

  // useEffect(() => {
  //   if (productList.length === 0 && orderData?.store_uid) {
  //     setPayloadItemsSearch((prevPayload) => {
  //       const updatedPayload = {
  //         ...prevPayload,
  //         keywords: {
  //           ...prevPayload.keywords,
  //           store_uid: orderData.store_uid,
  //         },
  //       }
  //       productSearch(updatedPayload, handleItemsSearchResponse, () => {})
  //       return updatedPayload
  //     })
  //   }
  // }, [orderData?.store_uid, productList.length])

  const handleChange = (index, key, rawValue) => {
    const updated = [...items]
    let cleanValue = cleanNumber(rawValue)

    let errorMessage = null

    if (key === 'product_quantity') {
      const maxQty = cleanNumber(updated[index].product_quantity_before)

      if (cleanValue > maxQty) {
        errorMessage = `${t('message.max_quantity')}: ${maxQty}`
        cleanValue = maxQty
      }
    }

    // Update error state berdasarkan indeks produk
    setError((prev) => ({
      ...prev,
      [`${key}_${index}`]: errorMessage,
    }))

    updated[index][key] = cleanValue

    if (key === 'product_quantity') {
      const qty = cleanNumber(updated[index].product_quantity)
      const price = cleanNumber(updated[index].product_price)
      updated[index].product_total_price = qty * price
    }

    setItems(updated)
    const totalOrder = updated
      .filter((item) => item.is_deleted !== 1)
      .reduce((acc, item) => acc + cleanNumber(item.product_total_price), 0)
    const shippingCost = cleanNumber(totalData.shippingCost)
    const insuranceCost = cleanNumber(totalData.insuranceCost)
    const totalPayment = totalOrder + shippingCost + insuranceCost

    setTotalData({
      ...totalData,
      shippingCost,
      insuranceCost,
      totalOrder,
      totalPayment,
    })
  }

  const handleSubmitSearch = (e) => {
    e.preventDefault()
    const updatedPayload = {
      ...payloadItemsSearch,
      page: 1,
      keywords: { ...payloadItemsSearch.keywords, text_search: keyword },
    }
    setPayloadItemsSearch(updatedPayload)
  }

  const handleReset = (e) => {
    e.preventDefault()
    setKeyword('')
    const updatedPayload = {
      ...payloadItemsSearch,
      page: 1,
      keywords: { ...payloadItemsSearch.keywords, text_search: '' },
    }
    setPayloadItemsSearch(updatedPayload)
  }

  const calculateTotals = (items, prevTotal) => {
    const totalOrder = items
      .filter((item) => item.is_deleted !== 1)
      .reduce((acc, item) => acc + cleanNumber(item.product_total_price), 0)

    return {
      ...prevTotal,
      totalOrder,
    }
  }

  useEffect(() => {
    if (items && items.length > 0) {
      const totals = calculateTotals(items, totalData)

      if (totals?.totalOrder !== totalData?.totalOrder) {
        setTotalData(totals)
      }
    }
  }, [items, items.length, setTotalData, totalData])

  const resetAllocationWithPatch = (items, targetIndex, patchForTarget) => {
    return items.map((item, i) => {
      const baseAllocatedBefore =
        item.product_amount_allocated === 0
          ? item.product_amount_allocated_original
          : item.product_amount_allocated

      if (i !== targetIndex) {
        return {
          ...item,
          product_amount_allocated_before: baseAllocatedBefore,
          product_amount_allocated: 0,
        }
      }

      // item pada index yang diubah
      return {
        ...item,
        ...patchForTarget(item),
        product_amount_allocated_before: baseAllocatedBefore,
        product_amount_allocated: 0,
      }
    })
  }

  const applyItemChangeWithTotals = (index, patchForTarget) => {
    setItems((prevItems) => {
      const resetAllocated = resetAllocationWithPatch(prevItems, index, patchForTarget)

      setTotalData((prevTotal) => calculateTotals(resetAllocated, prevTotal))

      return resetAllocated
    })
  }

  const undoItem = async (index) => {
    const confirm = await confirmationAlert({
      icon: 'warning',
      message: t('message.confirmation_undo_product_correction'),
      title: t('title.are_you_sure'),
    })

    if (!confirm) return

    applyItemChangeWithTotals(index, () => ({
      is_deleted: 0,
      status_item: 'undo',
    }))
  }

  // ==================
  // REMOVE ITEM
  // ==================
  const removeItem = async (index) => {
    const confirm = await confirmationAlert({
      icon: 'warning',
      message: t('message.confirmation_remove_product_correction'),
      title: t('title.are_you_sure'),
    })

    if (!confirm) return
    applyItemChangeWithTotals(index, () => ({
      is_deleted: 1,
      status_item: 'deleted',
    }))
  }

  const handleTransaction = (item) => {
    setItems((prevItems) => {
      // Cek apakah transaksi ini sudah ada
      const isAlreadyExist = prevItems.some((i) => i.shipping_code === item.shipping_code)

      let updated = []

      if (isAlreadyExist) {
        // Jika sudah ada, hapus
        updated = prevItems.filter((i) => i.shipping_code !== item.shipping_code)
      } else {
        // Jika belum ada, mapping produk baru
        const newItemsFrom = item?.shipping_items?.map((product) => ({
          transaction_code: item.transaction_code,
          transaction_uid: item.transaction_uid,
          transaction_item_uid: product.transaction_item_uid,
          transaction_shipping_header_uid: item.uid,
          created_by: product.created_by,
          product_title: product.product_title,
          product_quantity: product.product_quantity,
          product_quantity_before: product.product_quantity,
          product_price: product.product_price_item,
          product_price_dpp: product.product_price_dpp,
          product_price_pph: product.product_price_pph,
          product_price_ppn: product.product_price_ppn,
          product_tax: product.product_tax,
          product_total_price: product.product_price_item * product.product_quantity,
          product_total_price_before: product.product_price_item * product.product_quantity,
          product_thumbnail: product.product_thumbnail,
          product_type: product.product_type,
          product_price_currency: product.product_price_currency,
          product_uid: product.product_uniqueid,
          product_trx_uid: product.uid,
          product_status: 'added',
          product_unit_type: product.product_unit_type,
          is_deleted: 0,
          status_item: 'added',
          shipping_code: item.shipping_code,
          shipping_date_delivered: item.shipping_date_delivered,
          shipping_date_sent: item.shipping_date_sent,
          shipping_note: item.shipping_note,
          shipping_number: item.shipping_number,
          shipping_items: item.shipping_items,
          bill_status: item.bill_status,
          bill_code: item.bill_code,
          initial_status: item.initial_status,
        }))

        updated = [...prevItems, ...newItemsFrom]
      }

      // setTotalData butuh array terbaru, kita hitung di sini
      const totals = calculateTotals(updated, totalData)
      setTotalData(totals)

      return updated
    })
  }

  const handleUploadMultiple = (e) => {
    const files = Array.from(e.target.files)
    const name = e.target.name

    files.forEach((file) => {
      let isValidImage = checkValidationFile(file.type, file.size)
      if (!isValidImage) {
        setError((prev) => ({ ...prev, [name]: t('message.invalid_picture') }))
        return
      }

      // maksimal 5 foto
      if (detailReturn?.retur_attachment?.length >= 5) {
        showAlert({
          icon: 'warning',
          message: t('message.product_validate'),
          reload: false,
        })
        return
      }

      new Compressor(file, {
        quality: 0.8,
        maxWidth: 1200,
        success: (compressedResult) => {
          const payload = {
            type: 'PUBLIC',
            category: 'RETUR_PROOF',
            file: new File(
              [compressedResult],
              `${Date.now().toString()}.${compressedResult.name.split('.').pop()}`,
              {
                type: compressedResult.name.split('.').pop(),
              },
            ),
            reference_uid: account.uid,
            updated_by: account.full_name,
          }
          uploadImage(payload, (response) => {
            setDetailReturn((prev) => {
              const safeAttachments = Array.isArray(prev?.retur_attachment)
                ? prev.retur_attachment
                : []

              return {
                ...prev,
                retur_attachment: [...safeAttachments, response],
              }
            })
          })
        },
        error(err) {
          console.error('Compression error:', err.message)
        },
      })
    })

    setError((prev) => ({ ...prev, [name]: null }))
  }

  const handleRemovePhoto = (indexToRemove) => {
    setDetailReturn((prev) => ({
      ...prev,
      retur_attachment: prev.retur_attachment.filter((_, index) => index !== indexToRemove),
    }))
  }
  const [expandedId, setExpandedId] = useState([])
  const groupedByShipping = useMemo(() => {
    return items.reduce((acc, item) => {
      const code = item.shipping_code
      if (!acc[code]) acc[code] = []
      acc[code].push(item)
      return acc
    }, {})
  }, [items])

  const [lastGroupCount, setLastGroupCount] = useState(0)

  useEffect(() => {
    const currentGroups = Object.keys(groupedByShipping)

    if (currentGroups.length > lastGroupCount) {
      setExpandedId(currentGroups)
      setLastGroupCount(currentGroups.length)
    }
  }, [groupedByShipping, lastGroupCount])

  useEffect(() => {
    if (currentPage === 'view') {
      const isFinished = items.length > 0 && items.every((item) => item.shipping_code !== '')

      if (isFinished || (items.length === 0 && orderData?.uid)) {
        setInternalLoading(false)
      }
    }
  }, [items, currentPage, orderData])

  const toggleAccordion = (shippingCode) => {
    setExpandedId(
      (prev) =>
        prev.includes(shippingCode)
          ? prev.filter((id) => id !== shippingCode) // Tutup: Hapus dari array
          : [...prev, shippingCode], // Buka: Tambah ke array
    )
  }

  const handleToggleAll = (currentlyAllChecked) => {
    const newItems = items.map((item) => ({
      ...item,
      is_deleted: !currentlyAllChecked ? 0 : 1,
    }))
    setItems(newItems)
  }

  if (internalLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center height-100vh">
        <Loading />
      </div>
    )
  }

  return (
    <div>
      <div className="mb-2 fw-bold">{label}</div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          {currentPage !== 'view' && (
            <button className="btn btn-sm btn-primary pointer" onClick={() => setShowModal(true)}>
              + {t('button.add_product')}
            </button>
          )}
        </div>

        <div className="d-flex flex-end align-items-center" style={{ gap: '20px' }}>
          {/* SELECT ALL */}
          {currentPage !== 'view' && items.length > 0 && (
            <div
              className="form-check small d-flex align-items-center mb-0"
              style={{ cursor: 'pointer' }}
            >
              <input
                type="checkbox"
                className="form-check-input mt-0"
                id="globalSelect"
                style={{ cursor: 'pointer' }}
                checked={items.length > 0 && items.every((i) => i.is_deleted === 0)}
                onChange={() => {
                  const isAllChecked = items.every((i) => i.is_deleted === 0)
                  handleToggleAll(isAllChecked)
                }}
              />
              <label
                className="form-check-label pointer ml-2 mb-0 fw-bold text-primary"
                htmlFor="globalSelect"
              >
                {t('button.select_all')}
              </label>
            </div>
          )}
        </div>
      </div>

      <div className="card p-3 shadow-sm border-0">
        {Object.keys(groupedByShipping).length > 0 ? (
          <div className="accordion">
            {Object.keys(groupedByShipping).map((shippingCode) => {
              const isOpen = expandedId.includes(shippingCode)
              return (
                <div className="card mb-2" key={shippingCode}>
                  <div className="card-header bg-white p-0">
                    <h2 className="mb-0">
                      <button
                        className="btn btn-link btn-block text-left d-flex justify-content-between align-items-center py-3 px-4 text-decoration-none"
                        type="button"
                        onClick={() => toggleAccordion(shippingCode)}
                      >
                        <span className="text-dark fw-bold">
                          <i
                            className={`fa fa-chevron-${
                              expandedId?.includes(shippingCode) ? 'down' : 'right'
                            } mr-2 text-muted`}
                          ></i>
                          {shippingCode}
                        </span>
                        <span className="badge badge-pill badge-primary text-white">
                          {groupedByShipping[shippingCode].length} Produk
                        </span>
                      </button>
                    </h2>
                  </div>

                  {isOpen && (
                    <div className="card-body p-0 border-top">
                      <div className="d-flex align-items-center fw-semibold text-muted bg-light py-2 px-3 mx-3 mt-2 rounded">
                        {currentPage !== 'view' && (
                          <div style={{ width: '30px' }} className="mr-2"></div>
                        )}

                        <div className="col-md-4">{t('title.product.product_name')}</div>
                        <div className="col-md-2">{t('title.product.product_total')}</div>
                        <div className="col-md-3">{t('title.product.product_price')}</div>
                        <div className="col-md-3">{t('title.product.price_total')}</div>
                      </div>

                      {groupedByShipping[shippingCode].map((item, idx) => {
                        const globalIndex = items.findIndex((i) => i === item)

                        return (
                          <div
                            key={idx}
                            className="d-flex align-items-center p-3 border-bottom mx-3"
                          >
                            {currentPage !== 'view' && (
                              <div className="mr-3">
                                <input
                                  type="checkbox"
                                  checked={!item.is_deleted}
                                  onChange={() =>
                                    item.is_deleted
                                      ? undoItem(globalIndex)
                                      : removeItem(globalIndex)
                                  }
                                />
                              </div>
                            )}

                            <div className="col-md-4 d-flex align-items-center" style={{ flex: 2 }}>
                              <img
                                alt={`${item.product_title}`}
                                src={item.product_thumbnail}
                                width="50"
                                className="rounded mr-2 border"
                              />
                              <div className="small fw-bold">{item.product_title}</div>
                            </div>

                            <div className="col-md-2">
                              <InputQuantity
                                id={`product_quantity-${globalIndex}`}
                                value={item.product_quantity}
                                onChange={(val) =>
                                  handleChange(globalIndex, 'product_quantity', val.value)
                                }
                                readOnly={item.is_deleted || currentPage === 'view'}
                                zeroMinValue={true}
                                decimal={2}
                              />
                              {error?.[`product_quantity_${globalIndex}`] && (
                                <div
                                  className="text-danger fw-bold mt-1"
                                  style={{ fontSize: '10px', lineHeight: '1.2' }}
                                >
                                  {error[`product_quantity_${globalIndex}`]}
                                </div>
                              )}
                            </div>
                            <div className="col-md-3 flex-grow-1">
                              <InputCurrency
                                id="product_price"
                                currency="IDR"
                                value={item.product_price}
                                readOnly
                              />
                            </div>

                            <div className="col-md-3 flex-grow-1">
                              <InputCurrency
                                id="product_total_price"
                                currency="IDR"
                                value={item.product_total_price}
                                readOnly
                              />
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        ) : (
          <div className="card p-5 text-center text-muted bg-light">
            {t('form.not_found_product')}
          </div>
        )}

        <div className="row g-3 pt-4">
          <div className="col-md-6 pb-2 text-end fw-semibold">{t('title.total_return')}</div>
          <div className="col-md-6 pb-2 mb-2">
            <InputCurrency
              id="total_order"
              value={totalData?.totalOrder}
              decimal={2}
              readOnly
              currency="IDR"
            />
          </div>

          {/* FIELD UPLOAD BUKTI */}
          <div className="col-md-6 text-end fw-semibold">{t('form.return_attachment')}</div>
          <div className="col-md-6">
            <div className="d-flex align-items-start gap-3 flex-wrap">
              {(Array.isArray(detailReturn?.retur_attachment)
                ? detailReturn.retur_attachment
                : detailReturn?.retur_attachment?.split(',').filter((val) => val) || []
              ).map((img, index) => {
                const imageSrc = typeof img === 'string' ? img : URL.createObjectURL(img)
                return (
                  <div
                    key={index}
                    style={{
                      width: '120px',
                      height: '120px',
                      position: 'relative',
                      marginRight: '1rem',
                      cursor: 'pointer',
                    }}
                  >
                    <ImageModal
                      src={imageSrc}
                      title={`${t('form.return_attachment')} - ${index + 1}`}
                      style={{ width: '120px', height: '120px', borderRadius: '5px' }}
                    />
                    {currentPage !== 'view' && (
                      <button
                        className="btn btn-danger btn-sm"
                        style={{ position: 'absolute', top: 1, right: 1 }}
                        onClick={() => handleRemovePhoto(index)}
                      >
                        x
                      </button>
                    )}
                  </div>
                )
              })}
              {/* Tambah Foto */}
              {currentPage !== 'view' && (detailReturn?.retur_attachment?.length || 0) < 5 && (
                <div
                  className="form-picture"
                  style={{
                    width: '120px',
                    height: '120px',
                    minWidth: '120px',
                    position: 'relative',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    border: '2px dashed #ccc',
                    backgroundColor: '#f8f9fa',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <div className="text-center" style={{ cursor: 'pointer' }}>
                    <i className="fas fa-camera" style={{ fontSize: '20px', color: '#6c757d' }}></i>
                    <div style={{ fontSize: '10px', color: '#6c757d', fontWeight: 'bold' }}>
                      {currentPage !== 'view' ? t('placeholder.upload_image') : ''}
                    </div>
                  </div>
                  <input
                    type="file"
                    multiple
                    onChange={handleUploadMultiple}
                    style={{ position: 'absolute', opacity: 0, width: '100%', height: '100%' }}
                    disabled={currentPage === 'view'}
                  />
                </div>
              )}

              <div className="small text-muted m-1">
                {error?.retur_attachment && (
                  <div className="text-danger fw-bold mb-1">{error?.retur_attachment}</div>
                )}
                {currentPage !== 'view' && (
                  <span>
                    {t('form.image_size')} <br />
                    {t('form.image_type')}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ReturnShippingModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onResetPagination={handleResetPagination}
        shippingList={dataShipping}
        onToggle={handleTransaction}
        onPageChange={handleChangePage}
        pagination={pagination}
        items={items}
        handleSubmitSearch={handleSubmitSearch}
        setKeyword={setKeyword}
        keyword={keyword}
        handleReset={handleReset}
      />
    </div>
  )
}

ReturnItemsSection.propTypes = {
  label: PropTypes.string.isRequired,
  orderData: PropTypes.object,
  dataShipping: PropTypes.array,
  items: PropTypes.array.isRequired,
  setItems: PropTypes.func,
  totalData: PropTypes.object,
  setTotalData: PropTypes.func,
  error: PropTypes.object,
  setError: PropTypes.func,
  detailReturn: PropTypes.object,
  setDetailReturn: PropTypes.func,
}

export default ReturnItemsSection
